import Tb1688Api from '@/api/auth_app/tb1688'
import searchImgBtnHandler from '../../handler'
import { CheckValidation } from '@/utils/co_util'
import { message } from 'ant-design-vue'
import { ItemType_Tb1688 } from '@/utils/constant/item'
import { Service_GetBranchRelId } from '@/service/branch_relId_service'
async function StartSearchImg({imgUrl,filter},orderInfo){
  var imgBase64 =  await searchImgBtnHandler.CanvasDataURL(imgUrl , {quality: 0.9, compressType: 1,})
  var data = {imageData:imgBase64, filter}
  var {itemList,msg,isSuccess,isAuth} =  await Tb1688Api.SearchTb1688GoodsByImg(data,Service_GetBranchRelId(orderInfo.relation,ItemType_Tb1688.type))
  if (isAuth && itemList) {
    await CheckValidation(itemList , {
      content1: '当前还未授权1688，不能行进【1688以图搜款】操作，请点击【去授权】按钮，打开1688的授权页面 (新窗口)',
      okText1: '去授权',
      content2: '如您已经确认成功授权1688，请点击【确定】按钮，继续进行操作',
      okText2: '确定'
    })
    return StartSearchImg({ imgUrl }, orderInfo)
  }
  else if (!isSuccess) message.warn(`1688搜图失败，原因:【${msg}】`) 
  itemList =  updataItemList(itemList)
  return itemList
}


function updataItemList(itemList){
    
  if(itemList.length == 0) return itemList

  var newItemList = itemList.map(item => {
    var newItem = {
      link:  `https://detail.1688.com/offer/${item.ItemId}.html`,
      imgUrl: item.Pic,
      nid: item.ItemId,
      zkFinalPrice: item.Price,
      tejiaTotalSoldQuantity: item.Sold,
      title:item.Title,
      tagList:item.serviceList
    }

    return newItem
  })
  return newItemList
}


const config = {

}






export default {StartSearchImg,config}